import { NavHideIcon, NavIcon } from "@src/components/elements";
import { Nav } from "@src/components/modules/Nav/Nav";
import { Page } from "@src/shared/pages";
import React, { useState } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 100000;

  .hamburger {
    position: absolute;
    z-index: 2;
    top: 1rem;
    left: 1rem;
    display: inline-flex;
    width: 2rem;
    height: 2rem;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: var(--transition);
    border-radius: var(--rounded-corner);
    fill: var(--border-gray-light);
    &:hover {
      background: var(--background-green);
    }
  }

  .content {
    padding: 4rem 0rem 1.5rem 0rem;
    width: 0;
    display: none;
    background-color: var(--secondary-black);
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    &.open {
      display: block;
      width: 18rem;
      overflow-y: scroll;
    }
  }

  .background {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.25);
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    &.open {
      display: block;
    }
  }
`;

export const MobileSidebar: React.FC<{
  activePage?: Page;
}> = ({ activePage }) => {
  const [open, setOpen] = useState(false);
  const toggleMenu = () => {
    setOpen(!open);
  };

  return (
    <StyledRoot className={open ? "open" : ""}>
      <div className="hamburger" onClick={toggleMenu}>
        {open ? <NavHideIcon /> : <NavIcon />}
      </div>
      <div className={`content ${open ? "open" : ""}`}>
        <Nav activePage={activePage} />
      </div>
      <div
        className={`background ${open ? "open" : ""}`}
        onClick={toggleMenu}
      ></div>
    </StyledRoot>
  );
};
